import { type Address } from 'viem';

export const CHAIN_ID = process.env.REACT_APP_CHAIN_ID ?? '';
export const VESTING_CONTRACT_ADDRESS = (process.env.REACT_APP_VESTING_CONTRACT_ADDRESS ?? '') as Address;
export const WALLETCONNECT_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID ?? '';
